import { useEffect, useState } from "react"
import { subscribeCityChatUnread } from "@/features/city/cityChatUnread"

/** Пробрасывает unread в document для бейджей (PlayLayout). */
export function useCityChatUnreadFlag(): boolean {
  const [hasUnread, setHasUnread] = useState(false)
  useEffect(() => subscribeCityChatUnread(setHasUnread), [])
  return hasUnread
}

export default function CityChatUnreadBridge() {
  const hasUnread = useCityChatUnreadFlag()
  useEffect(() => {
    document.documentElement.dataset.cityChatUnread = hasUnread ? "1" : "0"
  }, [hasUnread])
  return null
}
